package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.MemberRepository
import com.clany.backoffice.model.MemberResponse
import dev.zacsweers.metro.Inject

class GetMembersUseCase @Inject constructor(
    private val repository: MemberRepository
) {
    suspend operator fun invoke(
        page: Int = 1,
        pageSize: Int = 20,
        query: String? = null
    ): Result<List<MemberResponse>> = repository.getMembers(page, pageSize, query)
}
